export class Kubun {
    constructor() {
        this.body = {};
        this.html = {};
        this.formElem = {};
        this.formBtnElem = {};
        this.radioNodeList = {};
    }

    init() {
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];

        //#form-kubun  button type="submit"
        if (document.getElementById('form-kubun')) {
            this.formElem = document.getElementById('form-kubun');
            this.formBtnElem = this.formElem.querySelector('button[name="submitNext"]');
            this.radioNodeList = this.formElem.kibo_kaiin_kubun; //name
            //this.radioNodeList.value;

            this.formBtnElem.addEventListener('click', (e) => {
                e.preventDefault();
                //console.log('clicked');
                //console.log(this.radioNodeList);
                //console.log(this.radioNodeList.value);
                let url = this.radioNodeList.value;
                if (url === "") {
                    // 未選択
                } else {
                    window.location.href = url;
                }
            });
        }

        //.mw_wp_form フォームから区分選択へ戻るボタン
        //name="submitBackKubun"
        if (document.querySelectorAll('button[name="submitBackKubun"]')[0]) {
            let elem = document.querySelectorAll('button[name="submitBackKubun"]')[0];
            //console.log(elem);
            elem.addEventListener('click', (e) => {
                e.preventDefault();
                let url = '/regist/';
                if (url === "") {
                    // 未選択
                } else {
                    window.location.href = url;
                }
            });
        }
    }

    removeListener() {
        // addEventListener が重複して登録される https://qiita.com/yuki153/items/c909c54204eaab6ca1b2
    }



}